export let quality = "MD";

export const ArtworksCollection = [
    {
        name: "Foresta di ghiaccio in Appennino",
        description: "Monte Giovo (Appennino tosco emiliano)",
        position: { x: 0.245, y: 1.729, z: -3.569 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // piano terra lato destro, a destra
        size: 2.37,
        url: "DSC08872.jpg",
        author: "Elia Lazzari",
        year: 2023,
        redirectUrl: "https://www.eliusoutdoor.com/"
    },
    {
        name: "Rami di ghiaccio",
        description: "Nel bosco ghiacciato del monte Giovo, in Appennino tosco emiliano.",
        position: { x: -2.784, y: 1.729, z: -3.569 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // piano terra lato destro, a sinistra
        size: 2.37,
        url: "DSC08854.jpg",
        author: "Elia Lazzari",
        year: 2023,
        redirectUrl: "https://www.eliusoutdoor.com/wild-appennino"
    },
    {
        name: "Campi collinari",
        description: "Bellissimi prati alle pendici del Monte Adone, in Appennino bolognese.",
        position: { x: -4.645, y: 1.689, z: -2.09 },
        rotation: { x: -31.415, y: -39.278, z: 50.269 }, // piano terra facciata centrale, a destra
        size: 1.35,
        url: "DSC08284.jpg",
        author: "Elia Lazzari",
        year: 2023,
        redirectUrl: "https://www.eliusoutdoor.com/wild-appennino"
    },
    {
        name: "Tutti siamo piccoli nella foresta",
        description: "La foresta è un luogo dove tutti siamo piccoli. Piccoli di fronte alla natura, piccoli di fronte alla vita. Piccoli di fronte a noi stessi.",
        position: { x: -4.645, y: 1.689, z: 0.71 },
        rotation: { x: -31.415, y: -39.278, z: 50.269 }, // piano terra facciata centrale, a sinistra
        size: 1.35,
        url: "DSC00504.jpg",
        author: "Elia Lazzari",
        year: 2023,
        redirectUrl: "https://www.eliusoutdoor.com/wild-appennino"
    },
    {
        name: "Disegni della natura",
        description: "La natura è un'artista. La sua opera è la vita. Le flange degli alberi sono i suoi pennelli, il cielo è la sua tela.",
        position: { x: -2.784, y: 1.63, z: 2.371 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // piano terra lato sinistro, a destra
        size: 2.37,
        url: "DSC00310-HDR.jpg",
        author: "Elia Lazzari",
        year: 2023,
        redirectUrl: "https://www.eliusoutdoor.com/wild-appennino"
    },
    {
        name: "Disegni della natura 2",
        description: "La natura è un'artista. La sua opera è la vita. Le flange degli alberi sono i suoi pennelli, il cielo è la sua tela.",
        position: { x: 0.245, y: 1.63, z: 2.371 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // piano terra lato sinistro, a sinistra
        size: 2.37,
        url: "DSC00286-HDR.jpg",
        author: "Elia Lazzari",
        year: 2023,
        redirectUrl: "https://www.eliusoutdoor.com/wild-appennino"
    },
    {
        name: "Disegni della natura 3",
        description: "La natura è un'artista. La sua opera è la vita. Le flange degli alberi sono i suoi pennelli, il cielo è la sua tela.",
        position: { x: -2.799, y: 5.589, z: -0.629 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // soppalco facciata destra, più lontana
        size: 1.225,
        url: "DSC00267-Migliorato-NR-HDR.jpg",
        author: "Elia Lazzari",
        year: 2023,
        redirectUrl: "https://www.eliusoutdoor.com/wild-appennino"
    },
    {
        name: "Antichi abitanti",
        description: "I boschi molto spesso nascondono tracce di antichi abitanti. Questa è una di queste. Un'antica casa di caccia, abbandonata da tempo, che si trova in una radura nascosta nel versante sud del Corno alle Scale.",
        position: { x: -0.120, y: 5.589, z: -0.629 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // soppalco facciata destra, più vicina
        size: 1.225,
        url: "DSC00238-Migliorato-NR-HDR-Modifica.jpg",
        author: "Elia Lazzari",
        year: 2023,
        redirectUrl: "https://www.eliusoutdoor.com/wild-appennino"
    },
    {
        name: "Fiabesca cascata",
        description: "Questa cascata si trova nelle pendici del Civetta, in piena val Zoldana, in autunno è un vero spettacolo.",
        position: { x: -0.12, y: 5.589, z: -0.584 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // soppalco facciata sinistra, più vicina
        size: 1.225,
        url: "EL_05920-Modifica.jpg",
        author: "Elia Lazzari",
        year: 2023,
        redirectUrl: "https://www.eliusoutdoor.com/rocky-dolomites"
    },
    {
        name: "Pattern d'autunno",
        description: "I colori dell'autunno sono sempre una fonte di ispirazione. Questa foto è stata scattata da una collina sopra una frazione della val di Zoldo, inquadrando la fitta foresta di larici ed abeti.",
        position: { x: -2.799, y: 5.589, z: -0.589 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // soppalco facciata sinistra, più lontana
        size: 1.225,
        url: "EL_07514.jpg",
        author: "Elia Lazzari",
        year: 2023,
        redirectUrl: "https://www.eliusoutdoor.com/rocky-dolomites"
    },
];
export default ArtworksCollection;